{
    "events__form_create_title": "New event",
    "events__form_edit_title": "Edit Event",
    "events__form_title_placeholder": "Add title",
    "events__form_agenda_placeholder": "Agenda (shared with all attendees)",
    "events__card_default_title": "Customer Visit",
    "events__form_customer_placeholder": "Select customer (optional)",
    "events__form_location_placeholder": "Enter location",
    "events__form_location_use_custom_address": "Use \"{{address}}\"",
    "events__form_address_type_bill_to": "Bill-to",
    "events__form_address_type_ship_to": "Ship-to",
    "events__form_address_type_primary": "Primary",
    "events__form_regular_event_label": "Recurring appointment",
    "events__form_created_by": "Created by {{ownerName}}",
    "events__form_create_toast__success_title": "Event created successfully",
    "events__form_time_start_placeholder": "Start time",
    "events__form_time_end_placeholder": "End time",
    "events__form_time_end_before_start": "The end time can't be before the start time.",
    "page_header__new_event": "Event",
    "card_tasks_open_one": "{{count}} open",
    "card_tasks_open_other": "{{count}} open",
    "card_tasks_overdue_one": "{{count}} Overdue",
    "card_tasks_overdue_other": "{{count}} Overdue",
    "card_time_format": "{{startTime}} – {{endTime}}",
    "card_log_button": "Log",
    "card_log_button_logged": "Logged",
    "card_protocol_attachments_one": "{{count}} attachment",
    "card_protocol_attachments_other": "{{count}} attachments",
    "card_protocol_tasks_one": "{{count}} task",
    "card_protocol_tasks_other": "{{count}} tasks",
    "card_protocol_offers_one": "{{count}} offer",
    "card_protocol_offers_other": "{{count}} offers",
    "card_protocol_insights_triaged_one": "{{count}} insight triaged",
    "card_protocol_insights_triaged_other": "{{count}} insights triaged",
    "card_protocol_open": "Open {{type}}",
    "card_protocol__no_customer_hint": "Can't log with no customer linked to event",
    "card_recurrence_weeks_one": "Every week",
    "card_recurrence_weeks_other": "Every {{count}} weeks",
    "events__form_date_label": "Date",
    "events__form_recurrence_repeat_every": "Repeat every",
    "events__form_recurrence_weeks": "weeks",
    "events__form_recurrence_on": "On",
    "events__form_recurrence_until_label": "Until",
    "event": "Event",
    "events__close": "Close",
    "events__edit": "Edit",
    "events__delete": "Delete",
    "events__delete_success": "Event deleted",
    "events__delete_error": "Error deleting event",
    "events__delete_confirmation__body": "This action can not be undone. Notes already recorded for appointments will remain.",
    "events__delete__title": "Delete event?",
    "events__recurrence_scope__title": "Edit recurring event",
    "events__recurrence_scope__body": "What should be updated?",
    "events__recurrence_scope__single": "Only this event",
    "events__recurrence_scope__following": "This and following events",
    "events__recurrence_scope__confirm": "Save",
    "events__drag_scope__title": "Move recurring event",
    "events__drag_scope__body": "What should be updated?",
    "events__drag_scope__single": "Only this event",
    "events__drag_scope__update_schedule": "Update recurring schedule",
    "events__drag_scope__confirm": "Save",
    "period__day": "Day",
    "period__week": "Week",
    "calendar_week_abbr": "CW",
    "today": "Today",
    "today_day_number_ordinal_one": "{{count}}st",
    "today_day_number_ordinal_two": "{{count}}nd",
    "today_day_number_ordinal_few": "{{count}}rd",
    "today_day_number_ordinal_other": "{{count}}th",
    "foreign_calendar": "Other calendar",
    "foreign_calendar__back_to_own": "Back to my calendar",
    "foreign_calendar__search": "Search colleagues",
    "foreign_calendar__viewing": "Calendar: {{name}}",
    "maps": "Maps",
    "date_picker__pick_day": "Pick a day",
    "date_picker__pick_week": "Pick a week",
    "calendar_nav__previous_day": "Previous day",
    "calendar_nav__next_day": "Next day",
    "calendar_nav__previous_week": "Previous week",
    "calendar_nav__next_week": "Next week",
    "calendar_day_suggestions_label": "Suggested Visits",
    "calendar_day_suggestions_show_more": "Show more",
    "calendar_day_suggestions_show_less": "Show less",
    "calendar_day_suggestions_empty": "None",
    "recommended_customers_tier_a": "En route",
    "recommended_customers_tier_b": "Route adjacent",
    "recommended_customers_tier_c": "Similar region",
    "suggestion_feedback__title": "What's wrong with this recommendation?",
    "suggestion_feedback__reason_set_inactive": "Set customer inactive",
    "suggestion_feedback__reason_set_inactive_hint": "Hides the customer everywhere in Plato, not just here.",
    "suggestion_feedback__reason_never_visited": "This customer is never visited",
    "suggestion_feedback__reason_too_frequent": "This customer is suggested too often",
    "suggestion_feedback__frequency_label": "How often do you want to see this customer?",
    "suggestion_feedback__frequency_weeks": "Every {{weeks}} weeks",
    "suggestion_feedback__submit": "Hide recommendation",
    "suggestion_feedback__submit_inactive": "Set customer inactive",
    "suggestion_feedback__toast_hidden": "Recommendation hidden",
    "suggestion_feedback__toast_inactive": "Customer set to inactive",
    "suggestion_feedback__inactive_reason": "Marked inactive via recommendation feedback",
    "suggestion_feedback__error": "Something went wrong. Please try again.",
    "viewing_banner_text": "You are viewing <strong>{{name}}</strong>'s events",
    "viewing_banner_back": "Back to my events",
    "open_route_in_maps": "Open route in Maps",
    "events__form_attendees_placeholder": "Add an attendee",
    "events__form_attendees_invalid_email": "Please enter a valid email address",
    "events__form_attendees_no_email": "No email address",
    "fake_door_next_event_button": "Schedule next visit",
    "fake_door_next_event_toast_title": "Coming soon",
    "fake_door_next_event_toast_description": "We're working on letting you schedule the next visit directly from here.",
    "aria__schedule_event": "Schedule event",
    "aria__dismiss_suggestion": "Dismiss suggestion",
    "empty_day__title": "No events",
    "new_event_button": "New event",
    "calendar_day_suggestions_reveal": "Suggest visits",
    "calendar_day_suggestions_title": "Suggestions",
    "events__details_customer_button": "Customer"
}
